import { getNumbersWithDecimalPlaces } from '../money';
import { getDateTimeFromTimestamp } from '../datetime';

/**
 * Manuplate array of items to desirable table data.
 * @param {array} values
 * @returns {array}
 */
export function modifyItems(values) {
  return values.map((item) => {
    var temp = Object.assign({}, item);
    if (item?.last_transaction?.cate_id === 'send' && item?.last_transaction.hasOwnProperty('sends')) {
      temp.amount = getNumbersWithDecimalPlaces(item.last_transaction.sends[0].amount);
    }
    if (item?.last_transaction?.cate_id === 'receive' && item?.last_transaction.hasOwnProperty('receives')) {
      temp.amount = getNumbersWithDecimalPlaces(item.last_transaction.receives[0].amount);
    }
    if (item?.last_transaction?.time_at) {
      temp.last_transaction_date = getDateTimeFromTimestamp(item.last_transaction.time_at * 1000);
    }
    return temp;
  });
}
